import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import { LayoutProvider, UiProvider } from "@uigovpe/components";
import { WebgateApiBridge } from "@/infrastructure/providers/webgateApiBridge";
import { ToastProvider } from './components/toast-provider';

import { AppRouter } from './routes/router';
import 'material-symbols/outlined.css';
import './styles/globals.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <WebgateApiBridge />
    <LayoutProvider>
      <UiProvider>
        <ToastProvider>
          <Router basename="/app/empreende-mulher">
            <AppRouter />
          </Router>
        </ToastProvider>
      </UiProvider>
    </LayoutProvider>
  </React.StrictMode>
);
